import { createApi } from '@reduxjs/toolkit/query/react';

import { apiWeeklyPlanner } from '~constants/api';

import { Request, rtkBaseQueryWrapper, unwrap, WithRefetchKey } from '~libs/axiosWrapper';
import { post } from '~libs/genericAction';
import { createThunks } from '~libs/reduxUtils';
import { Worker } from '~weekly-planner/lib/common';

export const typePrefix = 'weekly-planner-users';

const config = [{ actionType: 'sendSMS', apiPath: `${apiWeeklyPlanner}/users/sms`, method: post }];

export const { sendSMS } = createThunks(typePrefix, config);

export const usersApi = createApi({
  reducerPath: 'weeklyPlannerUsersApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiWeeklyPlanner }),
  tagTypes: ['users'],
  endpoints: (builder) => ({
    getUsers: builder.query<Worker[], Request & WithRefetchKey>({
      query: (arg) => {
        const { __refetchKey, ...params } = arg ?? {};
        return { url: '/users', method: 'GET', params };
      },
      serializeQueryArgs: ({ endpointName, queryArgs }) => {
        const { __refetchKey, ...stable } = queryArgs ?? {};
        return { endpointName, ...stable };
      },
      forceRefetch({ currentArg, previousArg }) {
        return currentArg?.__refetchKey !== previousArg?.__refetchKey;
      },
      providesTags: [{ type: 'users', id: 'LIST' }],
      transformResponse: (payload) => unwrap<Worker[]>(payload),
    }),
  }),
});

export const { useGetUsersQuery } = usersApi;
